import { Component, Inject, OnInit } from '@angular/core';
import { JoinComponent } from '../join/join.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OasisUser } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-select-oasis-id-dialog',
  templateUrl: './select-oasis-id-dialog.component.html',
  styleUrls: ['./select-oasis-id-dialog.component.css']
})
export class SelectOasisIdDialogComponent implements OnInit {

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<SelectOasisIdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) { 
    this.parentRef = data.parentRef
    this.oasisIdList = data.oasisIdList
  }

  oasisIdList: OasisUser[]
  parentRef: JoinComponent
  ngOnInit(): void {
  }
  selectId(item: OasisUser) {
    this.userService.checkId(item.userId).subscribe(res => {
      if(res.resultCode == '8888') {
        alert(res.message)
      } else {
        this.parentRef.selectUserId(item.userId, res.data);
        this.popupClose()
      }
    })
  }
  popupClose(){
    this.dialogRef.close();
  }
}
